import { STRINGS } from '@/constants/strings';
import { countPhoneDigits } from '@/utils/helper';
import * as yup from 'yup';

export const MESSAGES = STRINGS.mutatePlayer.validation;

const MAX_NAME_LENGTH = 100;
const MAX_EMAIL_LENGTH = 100;
export const MAX_AVATAR_FILE_SIZE = 10 * 1024 * 1024;
const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const createPlayerSchema = (todayStart: Date) =>
  yup
    .object({
      firstName: yup.string().trim().required(MESSAGES.fieldRequired).max(MAX_NAME_LENGTH),
      lastName: yup.string().trim().required(MESSAGES.fieldRequired).max(MAX_NAME_LENGTH),
      playerHeight: yup
        .string()
        .defined()
        .test(
          'height-inches',
          STRINGS.mutatePlayer.validation.playerHeightMustBeNumber,
          val => !val || /^\d{1,2}"?$/.test(val),
        )
        .max(3),
      gender: yup.string().trim(),
      level: yup
        .string()
        .matches(/^level_([1-9]|10)$/)
        .required(MESSAGES.fieldRequired),
      parentFirstName: yup.string().trim().required(MESSAGES.fieldRequired).max(MAX_NAME_LENGTH),
      parentLastName: yup.string().trim().required(MESSAGES.fieldRequired).max(MAX_NAME_LENGTH),
      // Required: distinguish "empty / only country code" → required vs "wrong length / leading 0" → invalid format.
      phoneNumber: yup
        .string()
        .required(MESSAGES.fieldRequired)
        .test('digits-range', STRINGS.mutatePlayer.validation.phoneNumberDigitsRange, val => {
          const n = countPhoneDigits(val);
          return n >= 10 && n <= 24;
        }),
      countryCode: yup.string().optional().nullable(),
      altPhoneNumber: yup
        .string()
        .test('digits-range', STRINGS.mutatePlayer.validation.altPhoneNumberDigitsRange, val => {
          const n = countPhoneDigits(val);
          if (n === 0) return true;
          return n >= 10 && n <= 24;
        }),
      altCountryCode: yup.string().optional().nullable(),
      email: yup
        .string()
        .trim()
        .required(MESSAGES.fieldRequired)
        .max(MAX_EMAIL_LENGTH)
        .matches(EMAIL_PATTERN, MESSAGES.emailInvalid)
        .email(MESSAGES.emailInvalid),
      streetAddress: yup.string().trim().defined().max(200),
      streetAddress2: yup.string().trim().defined().max(200),
      city: yup.string().trim().defined().max(100),
      state: yup.string().trim().defined(),
      zipCode: yup.string().trim().defined().max(15),
      birthDate: yup
        .date()
        .nullable()
        .defined()
        .test('birthDate-required', MESSAGES.fieldRequired, value => value instanceof Date)
        .test('not-future', MESSAGES.birthDateCannotBeFuture, value => {
          if (!(value instanceof Date)) return false;
          const selected = new Date(value);
          selected.setHours(0, 0, 0, 0);
          return selected.getTime() <= todayStart.getTime();
        }),
      needClubs: yup
        .string()
        .required(MESSAGES.fieldRequired)
        .test('needClubs', MESSAGES.fieldRequired, value => value === 'yes' || value === 'no'),
      dominantHand: yup
        .string()
        .required(MESSAGES.fieldRequired)
        .test(
          'dominantHand',
          MESSAGES.fieldRequired,
          value => value === 'left' || value === 'right',
        ),
      avatar: yup
        .object({
          uri: yup.string().required(MESSAGES.fieldRequired).optional().nullable(),
          fileSize: yup
            .number()
            .min(1)
            .max(MAX_AVATAR_FILE_SIZE, MESSAGES.avatarTooLarge)
            .optional(),
        })
        .optional()
        .nullable(),
    })
    .required();
